<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" md="12">
        <taxcodedetails></taxcodedetails>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import taxcodedetails from "@/components/MasterSetup/TaxCode/TaxCodeDetails.vue";
export default {
  name: "Taxcodesetup",
  components: {
    taxcodedetails,
  },
};
</script>
